var price = document.querySelector('.sub_total_main b').getAttribute('price');
document.querySelector('quantity-input input[name="quantity"]').addEventListener('change', function() {
    let qty = this.value;
    let updated_price = qty * price;
    document.querySelector('.sub_total_main b').textContent = `Rs. ${updated_price}.00`;
});

$(document).ready(function(){
  // if (window.innerWidth < 768) {
  //       $('#shopify-section-template--24698214547771__multicolumn_qbXVV7 .multicolumn .multicolumn-list').slick({
  //         infinite: false,
  //         speed: 300,
  //         slidesToShow: 1,
  //         slidesToScroll: 1,
  //         mobileFirst: true,
  //         dots: false
  //       });
  //   }
})